import * as Yup from 'yup';

export const validateSchema = Yup.object().shape({
    bankName: Yup.string().required(),
    bik: Yup.string().required(),
    number: Yup.number().required(),
    correspondentNumber: Yup.number().required()
});